window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.selectchoices-autocomplete').length) {
    import('./_choices-autocomplete.js').then((module) => {
      module.Init();
      // Make rebindChoicesAutocomplete globally available
      // window.rebindChoicesAutocomplete = module.rebindChoicesAutocomplete;
    });
  }
});

export default {};
